import styles from "./ChargingMethods.module.scss";
import MediaQuery from "react-responsive";
import Heading from "../Typography/Heading/Heading";
import CharingSlider from "./ChargingSlider/ChargingSlider";
import ChargingMethodsCard1 from "./ChargingMethodsCard1/ChargingMethodsCard1";
import ChargingMethodsCard2 from "./ChargingMethodsCard2/ChargingMethodsCard2";

export default function CharginMethods() {
  return (
    <div id="ChargingMethods" className={styles.chargingMethods}>
      <div className={`${styles.container} container`}>
        <div className={styles.title}>
          <Heading level="h3" fw={600}>
            Способы зарядки
          </Heading>
        </div>
      </div>
      <MediaQuery minWidth={1366}>
        <CharingSlider />
      </MediaQuery>
      <div className={styles.content}>
        <MediaQuery maxWidth={1365}>
          <ChargingMethodsCard1 />
          <ChargingMethodsCard2 />
        </MediaQuery>
      </div>
    </div>
  );
}
